import { Paper, styled } from '@mui/material';

export const FooterContainer = styled(Paper)(({ theme }) => ({
  boxShadow: theme.shadows[18],
  pointerEvents: 'auto',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  border: '0.8px solid',
  borderColor: theme.palette.divider,
}));
